import React from "react";
import { motion } from "framer-motion";
import contact from "../../assets/contact.jpg";

const Contact = () => {
  const handleClick = () => {
    window.location.href =
      "https://api.whatsapp.com/send/?phone=6282223968588&text&type=phone_number&app_absent=0";
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:dwihandaya@gmail.com";
  };

  return (
    <section
      id="Contact"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src={contact}
          alt="Contact Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-brand-900/90 via-brand-800/85 to-eco-900/85" />
      </div>

      {/* Decorative orbs */}
      <div className="absolute top-10 left-10 w-72 h-72 bg-brand-500/30 rounded-full blur-3xl animate-pulse-soft" />
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-eco-500/30 rounded-full blur-3xl animate-pulse-soft" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-12"
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider uppercase bg-white/10 text-white border border-white/30 backdrop-blur-md mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-eco-400" />
            Hubungi Kami
          </span>
          <h2 className="font-oswald text-3xl sm:text-4xl lg:text-5xl font-semibold text-white">
            Mari{" "}
            <span className="bg-gradient-to-r from-brand-300 to-eco-300 bg-clip-text text-transparent">
              Berkolaborasi
            </span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-5 gap-6 lg:gap-8 items-stretch">
          {/* Info Card */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-2 relative rounded-3xl overflow-hidden p-8 lg:p-10 bg-gradient-to-br from-white via-brand-50 to-eco-50 shadow-strong"
          >
            <div className="absolute top-0 right-0 w-32 h-32 bg-brand-200/40 rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-eco-200/40 rounded-full blur-3xl" />

            <div className="relative">
              <h3 className="font-oswald text-3xl lg:text-4xl font-semibold text-slate-900 mb-4 leading-tight">
                Ayo Terhubung dengan{" "}
                <span className="text-gradient">Kami!</span>
              </h3>
              <p className="font-overpass text-slate-700 text-base lg:text-lg leading-relaxed mb-8">
                Kami siap membantu Anda. Hubungi kami untuk konsultasi lebih
                lanjut mengenai layanan perizinan lingkungan atau pertanyaan
                lainnya. Jangan ragu, kami ada di sini untuk Anda!
              </p>

              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={handleClick}
                  className="group flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-eco-600 hover:bg-eco-700 text-white font-semibold shadow-lg shadow-eco-500/40 hover:shadow-eco-500/60 transition-all hover:-translate-y-0.5"
                  style={{ fontFamily: "Oswald, sans-serif" }}
                >
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                  WhatsApp Now
                </button>
                <button
                  onClick={handleEmailClick}
                  className="group flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-white hover:bg-slate-50 text-brand-700 border border-brand-200 font-semibold shadow-lg shadow-brand-500/20 hover:shadow-brand-500/40 transition-all hover:-translate-y-0.5"
                  style={{ fontFamily: "Oswald, sans-serif" }}
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  Email Us
                </button>
              </div>

              {/* Mini contact list */}
              <div className="mt-8 space-y-3 pt-6 border-t border-slate-200/60">
                <div className="flex items-center gap-3 text-sm text-slate-700 font-overpass">
                  <div className="w-8 h-8 rounded-lg bg-brand-100 text-brand-600 flex items-center justify-center">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </div>
                  <span>PT. Defra Water Technology, Indonesia</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-3 rounded-3xl overflow-hidden shadow-strong relative"
            id="mapsDefra"
          >
            <div className="absolute inset-0 border-4 border-white/20 rounded-3xl pointer-events-none z-10" />
            <iframe
              title="Defra Water Technology Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d541.859979311932!2d106.6640422433548!3d-6.344622747961242!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69e50013194a1d%3A0x94660fb10d6737bd!2sPT.%20DEFRA%20WATER%20TECHNOLOGY!5e0!3m2!1sen!2sid!4v1727399248505!5m2!1sen!2sid"
              width="100%"
              height="100%"
              allowFullScreen=""
              loading="lazy"
              className="w-full h-[400px] lg:h-full min-h-[400px]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
